<script>
    import {
        InputText,
        InputPassword,
        Select,
        Typography,
        Spinner,
        Button,
        Avatar,
        Row,
    } from '$lib/components/UI'
    import {
        capitalize,
        validateEmail,
        validarCuit,
        validarDni,
        validarLibreta,
    } from '$lib/utils'
    import { useParams, navigate } from 'svelte-navigator'
    import { API_URL } from '$lib/conf'
    import { fly } from 'svelte/transition'
    import Redirect from '$lib/components/layout/Redirect.svelte'
    import Frame from '$lib/components/layout/Frame.svelte'
    const params = useParams()
    let passwordStep = false
    let data = { nombre: '', apellido: '', email: '' }
    let name = ''
    let validEmail, validPassword, validPassword2, pwd
    let blockButton = false
    const tdoc = [
        { label: 'DNI', value: 'dni', validation: validarDni },
        { label: 'CUIT', value: 'cuit', validation: validarCuit },
        { label: 'CUIL', value: 'cuil', validation: validarCuit },
        {
            label: 'Libreta de Enrolamiento',
            value: 'le',
            validation: validarLibreta,
        },
        { label: 'Libreta Cívica', value: 'lc', validation: validarLibreta },
    ]
    const fakeFetch = (_) =>
        new Promise((resolve, reject) => {
            setTimeout((_) => {
                resolve({ provider: 'TEST EMPRESA - 2039885844' })
            }, 5000)
        })
    // const getData = _ => fakeFetch();
    function getData() {
        return fetch(`${API_URL}/status/${$params.uuid}`)
            .then(async (res) => {
                if (res.ok) {
                    return await res.json()
                } else {
                    throw new Error('Error al recuperar el usuario')
                }
            })
            .catch(async (res) => {
                return await res.text()
            })
    }
    let fetchData = getData()
    let validDocNo = false
    function sendData() {
        blockButton = true
        fetch(`${API_URL}/signup/${$params.uuid}`, {
            method: 'POST',
            body: JSON.stringify(data),
        })
            .then(async (res) => {
                blockButton = false
                if (res.ok) {
                    navigate('/result', {
                        state: {
                            title: '¡Usuario Creado!',
                            icon: 'faceIDPositive',
                            desc: 'El usuario fué creado con éxito. Por favor inicie sesión para comenzar a operar en el Portal de proveedores.',
                            buttonSet: [
                                { label: 'Iniciar sesión', navTo: '/login' },
                            ],
                        },
                    })
                } else {
                    throw new Error('No se creo el usuario.')
                }
            })
            .catch((_) => {
                blockButton = false
                navigate('/result', {
                    state: {
                        title: 'Error',
                        icon: 'faceIDNegative',
                        desc: 'Ocurrió un error al intentar crear el usuario, por favor intente de nuevo mas tarde.',
                        buttonSet: [
                            { label: 'Volver', type: 'other', navTo: -1 },
                        ],
                    },
                })
            })
    }
    $: name =
        data.nombre && data.apellido
            ? `${capitalize(data.nombre.split(' ').at(0))} ${capitalize(
                  data.apellido.split(' ').at(0)
              )}`
            : ''
    $: validSt1 =
        ['email', 'nombre', 'apellido', 'tipo_doc', 'doc_no'].every(
            (x) => !!data[x]
        ) &&
        validEmail &&
        validDocNo
    $: validSt2 = validSt1 && validPassword && validPassword2 && pwd
    $: console.log($params)
</script>

<Frame background="grey" style="padding: 56px 0">
    {#await fetchData}
        <span
            style="display: flex; width: 100%; height: 400px; align-items: center;justify-content: center;"
        >
            <Spinner />
        </span>
    {:then { provider, enableSignup }}
        {@const [company, cuit] = provider.split(' - ')}
        {#if enableSignup}
            {#if !passwordStep}
                <div>
                    <Typography
                        type="h3"
                        style="text-align: center;margin: 0; padding: 0"
                        >Creación de usuario para {company}</Typography
                    >
                    <Typography
                        type="body"
                        style="text-align: center;margin: 0; padding: 0"
                        color="grey-800"
                        >Por favor complete los campos a continuación, se
                        sugiere que se utilicen datos personales.</Typography
                    >
                    <InputText
                        required
                        label="Nombre/s"
                        bind:value={data.nombre}
                    />
                    <InputText
                        required
                        label="Apellido/s"
                        bind:value={data.apellido}
                    />
                    <Row>
                        <Select
                            required
                            label="Tipo de documento"
                            options={tdoc}
                            bind:value={data.tipo_doc}
                        />
                        <InputText
                            required
                            label="Documento"
                            maxLength={11}
                            bind:value={data.doc_no}
                            bind:valid={validDocNo}
                            validation={tdoc.find(
                                ({ value }) => value === data.tipo_doc
                            )?.validation}
                        />
                    </Row>
                    <InputText
                        required
                        label="Email"
                        bind:value={data.email}
                        bind:valid={validEmail}
                        validation={validateEmail}
                    />
                    <Button
                        disabled={!validSt1}
                        on:click={(_) => (passwordStep = true)}
                        label="Continuar"
                        style="width: 100%"
                    />
                </div>
            {:else}
                <div>
                    <Avatar {name} />
                    <Typography
                        type="h3"
                        style="text-align: center;margin: 0; padding: 0"
                        >Creación de contraseña</Typography
                    >
                    <Typography
                        type="body"
                        style="text-align: center;margin: 0; padding: 0"
                        color="grey-800"
                        >{name.split(' ').at(0)} por favor crea tu contraseña a continuación.</Typography
                    >
                    <InputPassword
                        label="Contraseña"
                        signUp
                        bind:value={data.password}
                        bind:valid={validPassword}
                        validations={[
                            {
                                helper: 'Debe tener al menos 8 caracteres',
                                func: (v) => v && v.length >= 8,
                            },
                            {
                                helper: 'Usa al menos un número o símbolo.',
                                func: (v) => v && v.match(/\d|\W|\s/),
                            },
                            {
                                helper: 'No debe contener tu nombre u apellido.',
                                func: (v) =>
                                    v &&
                                    !new RegExp(
                                        `${data.nombre}|${data.apellido}`,
                                        'i'
                                    ).test(v),
                                // !v.match(
                                //     new RegExp(
                                //         `${data.nombre}|${data.apellido}`,
                                //         "i"
                                //     )
                                // )
                            },
                        ]}
                        errorMsg="Password most be at the same."
                    />
                    <InputPassword
                        bind:value={pwd}
                        label="Repita contraseña"
                        bind:valid={validPassword2}
                        validation={(v) => v === data.password}
                        errorMsg="Las contraseñas deben coincidir"
                    />
                    <Button
                        disabled={!validSt2 || blockButton}
                        on:click={sendData}
                        label="Crear usuario"
                        style="width: 100%"
                    />
                    <Button
                        disabled={blockButton}
                        type="other"
                        on:click={(_) => (passwordStep = false)}
                        label="Volver"
                        style="width: 100%"
                    />
                </div>
            {/if}
        {:else}
            <Redirect
                path="/result"
                options={{
                    state: {
                        title: 'Este link ya ha sido usado',
                        desc: `Este link ya ha sido usado y se encuentra deshabilitado. Si ya creaste tu cuenta de usuario podes loguearte o recuperar tu contraseña desde la pantalla de inicio de sesión.`,
                        icon: 'claimNegative',
                        buttonSet: [
                            {
                                navTo: '/login',
                                label: 'Ir a Inicio de Sesión',
                            },
                        ],
                    },
                }}
            />
        {/if}
    {/await}
</Frame>

<style>
    div {
        width: 596px;
        /* height: 100%; */
        display: flex;
        position: relative;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        display: flex;
        margin: auto;
        align-items: center;
        padding: 48px 111px;
        gap: 10px;
        align-self: center;
        border: 1px solid #ebebeb;
        border-radius: 8px;
        background-color: var(--color-white);
    }
</style>
